import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
// fix重复push replace同一个location错误
// 获取原型对象上的push函数
const originalPush = VueRouter.prototype.push;
// 获取原型对象上的replace函数
const originalReplace = VueRouter.prototype.replace;
// 修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
// 修改原型对象中的replace方法
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err);
};
const routes = [
  // 免登录
  // {
  //     path: "/blank",
  //     name: "blank",
  //     component: () =>
  //         import ("@/views/blank.vue"),
  //     meta: {
  //         title: "登录",
  //         isLogin: true
  //     },
  // },
  {
    path: "/",
    name: "登录",
    component: () => import("@/views/login.vue"),
  },
  {
    path: "/Home",
    name: "首页",
    // redirect: '/concept',
    component: () => import("@/views/home.vue"),
    meta: {
      title: "首页",
      isLogin: true,
    },
    children: [
      // 二级路由
      // 专业概览
      {
        path: "/essential",
        name: "基本信息",
        component: () => import("@/views/concept/essential.vue"),
        meta: {
          title: "基本信息",
          isLogin: true,
        },
      },
      {
        path: "/standards",
        name: "国家教学标准",
        component: () => import("@/views/concept/standards.vue"),
        meta: {
          title: "国家教学标准",
          isLogin: true,
        },
      },
      {
        path: "/institutions",
        name: "专业开设院校",
        component: () => import("@/views/concept/institutions.vue"),
        meta: {
          title: "专业开设院校",
          isLogin: true,
        },
      },

      // 专业教学数据分析
      // 资源库画像
      {
        path: "/overallPortrait",
        name: "整体画像",
        component: () => import("@/views/teachingAnalysis/repositoryPortrait/overallPortrait.vue"),
        meta: {
          title: "整体画像",
          isLogin: true,
        },
      },
      {
        path: "/studentPortrait",
        name: "学生画像",
        component: () => import("@/views/teachingAnalysis/repositoryPortrait/studentPortrait.vue"),
        meta: {
          title: "学生画像",
          isLogin: true,
        },
      },
      {
        path: "/teacherPortrait",
        name: "教师画像",
        component: () => import("@/views/teachingAnalysis/repositoryPortrait/teacherPortrait.vue"),
        meta: {
          title: "教师画像",
          isLogin: true,
        },
      },
      {
        path: "/curriculumPortrait",
        name: "课程画像",
        component: () =>
          import("@/views/teachingAnalysis/repositoryPortrait/curriculumPortrait.vue"),
        meta: {
          title: "课程画像",
          isLogin: true,
        },
      },
      // 资源库建设进度跟踪
      {
        path: "/schedule",
        name: "任务进度规划",
        component: () => import("@/views/teachingAnalysis/construction/schedule.vue"),
        meta: {
          title: "任务进度规划",
          isLogin: true,
        },
      },
      {
        path: "/resourceBase",
        name: "资源库总体建设进度跟踪",
        component: () => import("@/views/teachingAnalysis/construction/resourceBase.vue"),
        meta: {
          title: "资源库总体建设进度跟踪",
          isLogin: true,
        },
      },
      {
        path: "/progressPlanning",
        name: "各参建院校建设进度规划",
        component: () => import("@/views/teachingAnalysis/construction/progressPlanning.vue"),
        meta: {
          title: "各参建院校建设进度规划",
          isLogin: true,
        },
      },
      {
        path: "/participating",
        name: "各参建院校建设进度",
        component: () => import("@/views/teachingAnalysis/construction/participating.vue"),
        meta: {
          title: "各参建院校建设进度",
          isLogin: true,
        },
      },
      {
        path: "/schedulePlanning",
        name: "各子项目建设进度规划",
        component: () => import("@/views/teachingAnalysis/construction/schedulePlanning.vue"),
        meta: {
          title: "各子项目建设进度规划",
          isLogin: true,
        },
      },
      {
        path: "/subproject",
        name: "各子项目建设进度",
        component: () => import("@/views/teachingAnalysis/construction/subproject.vue"),
        meta: {
          title: "各子项目建设进度",
          isLogin: true,
        },
      },
      {
        path: "/monitorIndexDataTrack",
        name: "monitorIndexDataTrack",
        component: () => import("@/views/teachingAnalysis/construction/monitorIndexDataTrack.vue"),
        meta: {
          title: "监测指标数据跟踪",
          isLogin: true,
        },
      },
      {
        path: "/contrastSituation",
        name: "contrastSituation",
        component: () => import("@/views/teachingAnalysis/construction/contrastSituation.vue"),
        meta: {
          title: "监测指标数据跟踪",
          isLogin: true,
        },
      },
      // 资源库分析报告
      {
        path: "/basicReport",
        name: "年度分析报告",
        component: () => import("@/views/teachingAnalysis/report/basicReport.vue"),
        meta: {
          title: "年度分析报告",
          isLogin: true,
        },
      },

      {
        path: "/qualityReport",
        name: "课程质量报告",
        component: () => import("@/views/teachingAnalysis/report/qualityReport.vue"),
        meta: {
          title: "课程质量报告",
          isLogin: true,
        },
      },
      {
        path: "/applicationReport",
        name: "教师应用报告",
        component: () => import("@/views/teachingAnalysis/report/applicationReport.vue"),
        meta: {
          title: "教师应用报告",
          isLogin: true,
        },
      },
      {
        path: "/learningReport",
        name: "学生学习报告",
        component: () => import("@/views/teachingAnalysis/report/learningReport.vue"),
        meta: {
          title: "学生学习报告",
          isLogin: true,
        },
      },
      {
        path: "/activeData",
        name: "无活动数据",
        component: () => import("@/views/teachingAnalysis/report/activeData.vue"),
        meta: {
          title: "无活动数据",
          isLogin: true,
        },
      },
      {
        path: "/monthlyReport",
        name: "月度分析报告",
        component: () => import("@/views/teachingAnalysis/report/monthlyReport.vue"),
        meta: {
          title: "月度分析报告",
          isLogin: true,
        },
      },
      {
        path: "/resourceLibrary",
        name: "其他维度分析报告",
        component: () => import("@/views/teachingAnalysis/report/resourceLibrary.vue"),
        meta: {
          title: "其他维度分析报告",
          isLogin: true,
        },
      },

      {
        path: "/marketAnalysis",
        name: "专业就业市场分析",
        component: () => import("@/views/marketAnalysis/marketAnalysis.vue"),
        meta: {
          title: "专业就业市场分析",
          isLogin: true,
        },
      },

      // 职业能力分析
      {
        path: "/positionQuery",
        name: "专业岗位查询",
        component: () => import("@/views/abilityAnalysis/positionQuery.vue"),
        meta: {
          title: "专业岗位查询",
          isLogin: true,
        },
      },
      {
        path: "/professionalPortrait",
        name: "职业画像",
        component: () => import("@/views/abilityAnalysis/professionalPortrait.vue"),
        meta: {
          title: "职业画像",
          isLogin: true,
        },
      },

      // 管理中心
      {
        path: "/account",
        name: "账户管理",
        component: () => import("@/views/managementCenter/account.vue"),
        meta: {
          title: "账户管理",
          isLogin: true,
        },
      },
      {
        path: "/questionnaire",
        name: "问卷管理",
        component: () => import("@/views/managementCenter/questionnaire.vue"),
        meta: {
          title: "问卷管理",
          isLogin: true,
        },
      },
      {
        path: "/menuManagement",
        name: "菜单管理",
        component: () => import("@/views/managementCenter/menuManagement.vue"),
        meta: {
          title: "菜单管理",
          isLogin: true,
        },
      },
      {
        path: "/roleManagement",
        name: "角色管理",
        component: () => import("@/views/managementCenter/roleManagement.vue"),
        meta: {
          title: "角色管理",
          isLogin: true,
        },
      },
      {
        path: "/professionTeachManagement",
        name: "专业教学标准管理",
        component: () => import("@/views/managementCenter/professionTeachManagement.vue"),
        meta: {
          title: "专业教学标准管理",
          isLogin: true,
        },
      },
      {
        path: "/schoolManagement",
        name: "院校管理",
        component: () => import("@/views/managementCenter/schoolManagement.vue"),
        meta: {
          title: "院校管理",
          isLogin: true,
        },
      },
      {
        path: "/threeTwoPlatformsManagement",
        name: "三级两平台管理",
        component: () => import("@/views/managementCenter/threeTwoPlatformsManagement.vue"),
        meta: {
          title: "三级两平台管理",
          isLogin: true,
        },
      },
      {
        path: "/pushRecordManagement",
        name: "推送记录管理",
        component: () => import("@/views/managementCenter/pushRecordManagement.vue"),
        meta: {
          title: "推送记录管理",
          isLogin: false,
        },
      },
      {
        path: "/platformInfoManagement",
        name: "平台信息管理",
        component: () => import("@/views/managementCenter/platformInfoManagement.vue"),
        meta: {
          title: "平台信息管理",
          isLogin: true,
        },
      },
      {
        path: "/BuildBasicDataManagement",
        name: "建设基础数据管理",
        component: () => import("@/views/managementCenter/BuildBasicDataManagement.vue"),
        meta: {
          title: "建设基础数据管理",
          isLogin: true,
        },
      },
      {
        path: "/scheduledTaskManagement",
        name: "定时任务管理",
        component: () => import("@/views/managementCenter/scheduledTaskManagement.vue"),
        meta: {
          title: "定时任务管理",
          isLogin: true,
        },
      },
      {
        path: "/reportDistribute",
        name: "报告下发",
        component: () => import("@/views/managementCenter/reportDistribute.vue"),
        meta: {
          title: "报告下发",
          isLogin: true,
        },
      },
      {
        path: "/accountCountry",
        name: "账户管理-国家端",
        component: () => import("@/views/managementCenter/administrationCountry.vue"),
        meta: {
          title: "账户管理-校园端",
          isLogin: true,
        },
      },
      {
        path: "/enterpriseListEntry",
        name: "合作企业录入",
        component: () => import("@/views/managementCenter/enterpriseListEntry.vue"),
        meta: {
          title: "合作企业录入",
          isLogin: true,
        },
      },
      {
        path: "/platform",
        name: "平台账号管理",
        component: () => import("@/views/managementCenter/platform.vue"),
        meta: {
          title: "平台账号管理",
          isLogin: true,
        },
      },
      {
        path: "/exportOfreports",
        name: "报告自动化导出",
        component: () => import("@/views/managementCenter/exportOfreports.vue"),
        meta: {
          title: "报告自动化导出",
          isLogin: true,
        },
      },
      {
        path: "/reportExportManagement",
        name: "报告导出管理",
        component: () => import("@/views/managementCenter/reportExportManagement.vue"),
        meta: {
          title: "报告导出管理",
          isLogin: true,
        },
      },
      // {
      //   path: "/library",
      //   name: "指标库",
      //   component: () => import("@/views/managementCenter/library.vue"),
      //   meta: { title: "指标库", isLogin: true },
      // },
      // {
      //   path: "/configuration",
      //   name: "指标配置",
      //   component: () => import("@/views/managementCenter/configuration.vue"),
      //   meta: { title: "指标配置", isLogin: true },
      // },
      {
        path: "/analysisReportManagement",
        name: "分析报告管理",
        component: () => import("@/views/managementCenter/analysisReportManagement.vue"),
        meta: {
          title: "分析报告管理",
          isLogin: true,
        },
      },
      {
        path: "/pushDataManagement",
        name: "推送数据管理",
        component: () => import("@/views/managementCenter/pushDataManagement.vue"),
        meta: {
          title: "推送数据管理",
          isLogin: false,
        },
      },
      {
        path: "/keyIssuanceRecordQuery",
        name: "密钥下发记录查询",
        component: () => import("@/views/managementCenter/keyIssuanceRecordQuery.vue"),
        meta: {
          title: "密钥下发记录查询",
          isLogin: false,
        },
      },
      {
        path: "/indexStatisticsManagement",
        name: "推送数据管理",
        component: () => import("@/views/managementCenter/indexStatisticsManagement.vue"),
        meta: {
          title: "指标统计管理",
          isLogin: false,
        },
      },
      {
        path: "/fileUpload",
        name: "文件上传",
        component: () => import("@/views/managementCenter/fileUpload.vue"),
        meta: {
          title: "文件上传",
          isLogin: false,
        },
      },
      {
        path: "/rawDataQuery",
        name: "原始数据查询",
        component: () => import("@/views/managementCenter/rawDataQuery.vue"),
        meta: {
          title: "原始数据查询",
          isLogin: true,
        },
      },
      {
        path: "/automated",
        name: "自动化管理",
        component: () => import("@/views/managementCenter/automated.vue"),
        meta: {
          title: "自动化管理",
          isLogin: true,
        },
      },
      // 任务推送
      {
        path: "/task",
        name: "任务列表",
        component: () => import("@/views/dataPush/task.vue"),
        meta: {
          title: "任务列表",
          isLogin: true,
        },
      },
      {
        path: "/weeklyMonitoring",
        name: "每周监测",
        component: () => import("@/views/dataPush/weeklyMonitoring.vue"),
        meta: {
          title: "每周监测",
          isLogin: true,
        },
      },
    ],
  },
  {
    path: "/exportMonitorIndexDataTrack",
    name: "exportMonitorIndexDataTrack",
    component: () =>
      import("@/views/teachingAnalysis/construction/exportMonitorIndexDataTrack.vue"),
    meta: {
      title: "导出监测指标数据跟踪表格",
      isLogin: true,
    },
  },
  {
    path: "/analysisReport",
    name: "查看月度分析报告",
    component: () => import("@/views/teachingAnalysis/report/analysisReport.vue"),
    meta: {
      title: "查看月度分析报告",
      isLogin: true,
    },
  },
  {
    path: "/historyCourse",
    name: "查看课程质量报告",
    component: () => import("@/views/teachingAnalysis/report/historyCourse.vue"),
    meta: {
      title: "查看课程质量报告",
      isLogin: true,
    },
  },

  {
    path: "/noActiveDataReport",
    name: "无活动数据分析报告",
    component: () => import("@/views/teachingAnalysis/report/noActiveDataReport.vue"),
    meta: {
      title: "无活动数据分析报告",
      isLogin: true,
    },
  },
  {
    path: "/tInformation",
    name: "查看教师应用报告和学生学习报告",
    component: () => import("@/views/teachingAnalysis/report/tInformation.vue"),
    meta: {
      title: "查看教师应用报告和学生学习报告",
      isLogin: true,
    },
  },
  {
    path: "/exportTInformation",
    name: "导出教师应用报告和学生学习报告",
    component: () => import("@/views/teachingAnalysis/report/exportTInformation.vue"),
    meta: {
      title: "导出教师应用报告和学生学习报告",
      isLogin: true,
    },
  },
  {
    path: "/individualizationReport",
    name: "分析报告",
    component: () => import("@/views/teachingAnalysis/report/individualizationReport.vue"),
    meta: {
      title: "分析报告",
      isLogin: true,
    },
  },
  {
    path: "/quarterlyReport",
    name: "查看季度分析报告",
    component: () => import("@/views/teachingAnalysis/report/quarterlyReport.vue"),
    meta: {
      title: "查看季度分析报告",
      isLogin: true,
    },
  },
  {
    path: "/basicReportTable",
    name: "basicReportTable",
    component: () => import("@/views/teachingAnalysis/report/basicReportTable.vue"),
    meta: {
      title: "年度基本报告",
      meta: {
        title: "年度基本报告",
        isLogin: true,
      },
    },
  },
  {
    path: "/exportMonthReport",
    name: "导出月度分析报告",
    component: () => import("@/views/teachingAnalysis/report/exportMonthReport.vue"),
    meta: {
      title: "导出月度分析报告",
      isLogin: false,
    },
  },
  {
    path: "/exportHalfYear",
    name: "导出半年度分析报告",
    component: () => import("@/views/teachingAnalysis/report/exportHalfYear.vue"),
    meta: {
      title: "导出半年度分析报告",
      isLogin: false,
    },
  },
  {
    path: "/exportMonthReportNew",
    name: "导出月度分析报告（新版本）",
    component: () => import("@/views/teachingAnalysis/report/exportMonthReportNew.vue"),
    meta: {
      title: "导出月度分析报告（新版本）",
      isLogin: false,
    },
  },
  {
    path: "/exportQualityReport",
    name: "导出课程质量报告",
    component: () => import("@/views/teachingAnalysis/report/exportQualityReport.vue"),
    meta: {
      title: "导出课程质量报告",
      isLogin: false,
    },
  },
  {
    path: "/exportProvinceReportCopy1",
    name: "导出省级整体报告",
    component: () => import("@/views/teachingAnalysis/report/exportProvinceReportCopy1.vue"),
    meta: {
      title: "导出省级整体报告",
      isLogin: false,
    }
  },
  {
    path: "/exportCountryReport",
    name: "导出国家级整体报告",
    component: () => import("@/views/teachingAnalysis/report/exportCountryReport.vue"),
    meta: {
      title: "导出国家级整体报告",
      isLogin: false,
    },
  },
  {
    path: "/exportCountryYearReport",
    name: "导出国家端监测运行年报",
    component: () => import("@/views/teachingAnalysis/report/exportCountryYearReport.vue"),
    meta: {
      title: "导出国家端监测运行年报",
      isLogin: false,
    },
  },
  {
    path: "/exportCountryYearReportCopy1",
    name: "导出国家端监测运行年报（第一部分）",
    component: () => import("@/views/teachingAnalysis/report/exportCountryYearReportCopy1.vue"),
    meta: {
      title: "导出国家端监测运行年报",
      isLogin: false,
    },
  },
  {
    path: "/exportCountryYearReportCopy2",
    name: "导出国家端监测运行年报（第二部分）",
    component: () => import("@/views/teachingAnalysis/report/exportCountryYearReportCopy2.vue"),
    meta: {
      title: "导出国家端监测运行年报",
      isLogin: false,
    },
  },
  {
    path: "/exportCountryMonthReport",
    name: "导出国家级整体报告",
    component: () => import("@/views/teachingAnalysis/report/exportCountryMonthReport.vue"),
    meta: {
      title: "导出国家级整体报告(月度)",
      isLogin: false,
    },
  },
  {
    path: "/exportCountryMonthReportCopy1",
    name: "导出国家级整体报告",
    component: () => import("@/views/teachingAnalysis/report/exportCountryMonthReportCopy1.vue"),
    meta: {
      title: "导出国家级整体报告(月度)",
      isLogin: false,
    },
  },
  {
    path: "/exportCountryMonthReportCopy2",
    name: "导出国家级整体报告",
    component: () => import("@/views/teachingAnalysis/report/exportCountryMonthReportCopy2.vue"),
    meta: {
      title: "导出国家级整体报告(月度)",
      isLogin: false,
    },
  },
  {
    path: "/exportQualitrAndopen",
    name: "导出国家级在线精品课视频公开课",
    component: () => import("@/views/teachingAnalysis/report/exportQualitrAndopen.vue"),
    meta: {
      title: "导出国家级在线精品课视频公开课",
      isLogin: false,
    },
  },
  {
    path: "/exportCountryYunxing",
    name: "国家级数据运行报告",
    component: () => import("@/views/teachingAnalysis/report/exportCountryYunxing.vue"),
    meta: {
      title: "国家级数据运行报告",
      isLogin: false,
    },

  },
  {
    path: "/exportCountryYunxingNew",
    name: "职业教育专业教学资源库运行报告new",
    component: () => import("@/views/teachingAnalysis/report/exportCountryYunxingNew.vue"),
    meta: {
      title: "职业教育专业教学资源库运行报告",
      isLogin: false,
    },
  },
  {
    path: "/exportCountryYunxingYearNew",
    name: "职业教育专业教学资源库运行报告new",
    component: () => import("@/views/teachingAnalysis/report/exportCountryYunxingYearNew.vue"),
    meta: {
      title: "职业教育专业教学资源库运行年度报告",
      isLogin: false,
    },
  },
  {
    path: "/fenxi",
    name: "查看年度分析报告",
    component: () => import("@/views/teachingAnalysis/report/fenxi.vue"),
    meta: {
      title: "查看年度分析报告",
      isLogin: false,
    },
  },
  {
    path: "/yunxing",
    name: "运行简报",
    component: () => import("@/views/teachingAnalysis/report/yunxing.vue"),
    meta: {
      title: "查看运行简报",
      isLogin: false,
    },
  },
  {
    path: "/provinceReport",
    name: "省级整体报告",
    component: () => import("@/views/teachingAnalysis/report/provinceReport.vue"),
    meta: {
      title: "省级整体报告",
      isLogin: false,
    },
  },
  {
    path: "/qualitrAndopen",
    name: "国家级视频公开课和在线精品课",
    component: () => import("@/views/teachingAnalysis/report/qualitrAndopen.vue"),
    meta: {
      title: "国家级视频公开课和在线精品课",
      isLogin: false,
    },
  },
  {
    path: "/countryYunxing",
    name: "国家级运行数据分析报告",
    component: () => import("@/views/teachingAnalysis/report/countryYunxing.vue"),
    meta: {
      title: "国家级运行数据分析报告",
      isLogin: false,
    },
  },

  {
    path: "/exportBasicReportTable",
    name: "导出基本报告",
    component: () => import("@/views/teachingAnalysis/report/exportBasicReportTable.vue"),
    meta: {
      title: "导出基本报告",
      isLogin: false,
    },
  },

  {
    path: "/exportBasicReportTableOther",
    name: "导出基本报告",
    component: () => import("@/views/teachingAnalysis/report/exportBasicReportTableOther.vue"),
    meta: {
      title: "导出基本报告（新版）",
      isLogin: false,
    },
  },
  {
    path: "/BasicReportTables",
    name: "导出基本报告",
    component: () => import("@/views/teachingAnalysis/report/BasicReportTables.vue"),
    meta: {
      title: "基本报告（新版）",
      isLogin: false,
    },
  },
  {
    path: "/exportyunxing",
    name: "导出运行简报",
    component: () => import("@/views/teachingAnalysis/report/exportyunxing.vue"),
    meta: {
      title: "导出运行简报",
      isLogin: false,
    },
  },
  {
    path: "/exportJidu",
    name: "导出季度报告",
    component: () => import("@/views/teachingAnalysis/report/exportQuarterlyReport.vue"),
    meta: {
      title: "导出季度报告",
      isLogin: false,
    },
  },
  {
    path: "/exportJiduNew",
    name: "导出季度报告（专业大数据）",
    component: () => import("@/views/teachingAnalysis/report/exportQuarterlyReportNew.vue"),
    meta: {
      title: "导出季度报告（专业大数据）",
      isLogin: false,
    },
  },
  {
    path: "/exportFenxi",
    name: "导出半年度分析报告",
    component: () => import("@/views/teachingAnalysis/report/exportFenxi.vue"),
    meta: {
      title: "导出半年度分析报告",
      isLogin: false,
    },
  },
  {
    path: "/exportFenxi1244",
    name: "导出1244年度分析报告",
    component: () => import("@/views/teachingAnalysis/report/exportFenxi1244.vue"),
    meta: {
      title: "导出1244年度分析报告",
      isLogin: false,
    },
  },
  {
    path: "/exportFenxiRank",
    name: "导出半年度分析报告（排名）",
    component: () => import("@/views/teachingAnalysis/report/exportFenxiRank.vue"),
    meta: {
      title: "导出半年度分析报告（排名）",
      isLogin: false,
    },
  },
  {
    path: "/exportFenxiRankbigData",
    name: "导出半年度分析报告大数据（排名）",
    component: () => import("@/views/teachingAnalysis/report/exportFenxiRankbigData.vue"),
    meta: {
      title: "导出半年度分析报告大数据（排名）",
      isLogin: false,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
export default router;
